import AttributeView from './AttributeView';
import './AttributeView.scss';

export default AttributeView;
